<template>
	<v-tooltip
		ref="tooltip"
		bottom
		:disabled="!showTooltip"
	>
		<template v-slot:activator="{ on }">
			<v-chip
				ref="chip"
				class="mr-2 my-1"
				@click="getFile"
				@click:close="delFile"
				:close="editMode"
				v-on="on"
				label
				link
			>
				<v-icon left>attach_file</v-icon>
				<div
					:id="'a-chip-' + file.serverName"
					class="text-truncate"
					:style="style"
				>
					{{ file.name }}
				</div>
			</v-chip>
		</template>
		{{ file.name }}
	</v-tooltip>
</template>

<script>
import { api } from '../../lib/api'
export default {
	data: () => {
		return {
			width: 0,
		}
	},
	props: {
		file: Object,
		editMode: Boolean,
		truncate: {
			type: Boolean,
			default: true
		},
		maxWidth: {
			type: Number,
			default: 360
		},
	},
	computed: {
		style() {
			return 'max-width: ' + (this.maxWidth - 50) + 'px;'
		},
		showTooltip() {
			if (this.width >= this.maxWidth - 50) return true
			else return false
		}
	},
	mounted() {
		setTimeout(() => {
			this.width = document.getElementById('a-chip-' + this.file.serverName).clientWidth
		}, 500)
	},
	methods: {
		getFile() {
			// window.open(api.path() + 'file?n=pr' + this.file.serverName)
			window.open(this.file.url)
		},
		delFile() {
			this.$emit('delFile', this.file)
		},
	}
}
</script>

<style scoped lang="css">
</style>
